import React, { useEffect, useState } from "react";
import TopHeader from "../../../components/TopHeader";
import SabhaSaarHeader from "../../../components/SabhaSaarHeader";
import UserInfo from "../../../components/UserInfo";
import Footer from "../../../components/Footer";
import { RootState } from "../../../store";
import { useSelector, useDispatch } from "react-redux";
import { fetchMeetingTypes } from "../../../features/upload/uploadSlice";
import { getFinancialYr } from "../../../features/common/commonSlice";
import Wrapper from "../../../assets/wrappers/PreviousMeetingsDetails";
import Eye from '../../../assets/images/icons/icons_view.png';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import protectedAPI from "../../../services/axiosInstance";
import { toast } from "react-toastify";

const IoArrowBack = require('react-icons/io5').IoArrowBack;
const PreviousMeetingsDetails: React.FC = () => {
    const [storageData, setStorageData] = useState<any>(() => {
        const saved = localStorage.getItem('loginDetails');
        try {
            return saved ? JSON.parse(saved) : {};
        } catch (e) {
            console.error('Failed to parse loginDetails from localStorage:', e);
            return {};
        }
    });

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { meetingTypes, loading, MeetingTypeFetched } = useSelector(
        (state: RootState) => state.upload
    );
    const { financialYr, currentFinYear } = useSelector(
        (state: RootState) => state.common
    );

    const [finYear, setFinYear] = useState("");

    useEffect(() => {
        if (currentFinYear) {
            setFinYear(currentFinYear);
        }
    }, [currentFinYear]);
    const [selectedMeeting, setSelectedMeeting] = useState("0");
    const [tableData, setTableData] = useState<any[]>([]);

    const finYearOptions = financialYr || [];

    const meetingTypeOptions = [
        { id: "0", name: "All Meeting Types" },
        ...(meetingTypes?.flatMap((parent: any) =>
            parent.sub_options.map((sub: any) => ({
                id: sub.id,
                name: sub.name,
            }))
        ) || []),
    ];

    useEffect(() => {
        if (!MeetingTypeFetched && !loading) {
            dispatch(fetchMeetingTypes() as any);
        }
    }, [MeetingTypeFetched, loading, dispatch]);

    useEffect(() => {
        dispatch(getFinancialYr() as any);
    }, [dispatch]);
    useEffect(() => {
        const fetchMeetings = async () => {
            setTableData([]);
            if (finYear) {
                try {
                    const response = await protectedAPI.get(`${baseUrl}api/meeting-viewer`, {
                        params: {
                            fin_year: finYear,
                            gpcode: storageData.gpcode,
                            bpcode: storageData.bpcode,
                            zpcode: storageData.zpcode,
                            statecode: storageData.state_code,
                            meeting_type: selectedMeeting !== "0" ? selectedMeeting : undefined,
                        },
                    });
                    if (response?.data?.msg_code === 400) {
                        toast.error(response?.data?.msg || "Something went wrong");
                        setTableData([]);
                        return;
                    }
                    setTableData(response?.data?.meetings || []);
                } catch (error) {
                    console.error("Error fetching meeting data:", error);
                }
            }
        };

        fetchMeetings();
    }, [finYear, selectedMeeting, baseUrl]);

    const handleViewClick = (task_id: any) => {
        navigate(`/meeting-details/${task_id}`);
    }
    return (
        <Wrapper>
            <TopHeader />
            <section className="body-content">
                <SabhaSaarHeader />
                <UserInfo />
                <div className="container" id="uploadMainSkip">
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <h5 className="card-title-cus">View Previous Meetings Details</h5>
                                <div className="goBack" onClick={() => navigate("/afterLogin")}>
                                    <IoArrowBack size={24} /> Back
                                </div>
                            </div>
                            <p className="mini-note-heading">
                                The recently generated minutes may take up to 10 minutes to reflect in this view.
                            </p>
                            <div className="row mt-4">
                                <div className="col-md-6">
                                    <select
                                        className="form-select"
                                        value={finYear}
                                        onChange={(e) => setFinYear(e.target.value)}
                                    >
                                        <option value="" disabled>
                                            Select Financial Year
                                        </option>
                                        {finYearOptions.map((year: string) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="form-select"
                                        value={selectedMeeting}
                                        onChange={(e) => setSelectedMeeting(e.target.value)}>
                                        <option value="0">All Meeting Types</option>
                                        {meetingTypes?.map((parent) => (
                                            <optgroup key={parent.id} label={parent.name}>
                                                {parent.sub_options.map((sub) => (
                                                    <option key={sub.id} value={sub.id}>
                                                        {sub.name}
                                                    </option>
                                                ))}
                                            </optgroup>
                                        ))}
                                    </select>

                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="table-responsive">
                                    <table className="table table-striped ">
                                        <thead className="thead">
                                            <tr>
                                                <th className="left-radius">S.No.</th>
                                                <th className="no-radius">Meeting Date</th>
                                                <th className="no-radius">Meeting Type</th>
                                                <th className="right-radius">View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableData.length > 0 ? (
                                                tableData.map((item: any, index: number) => (
                                                    <tr key={index}>
                                                        <td width={25}>{index + 1}.</td>
                                                        <td width={25}>{item.meeting_date}</td>
                                                        <td width={25}>{item.meeting_type}</td>
                                                        <td width={25}>
                                                            <img src={Eye} onClick={() => handleViewClick(item.task_id)} className="cursor-pointer eye" />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4} className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </Wrapper>
    );
};

export default PreviousMeetingsDetails;
